export default {
    allApps: 'settings/forevercloudstore.json',
    userAuth: 'reflex/auth/whoami',
    userLogOut: 'reflex/auth/logout',
    subs: 'settings/subscriptions',
    publish:'publish/',
    credentials: 'settings/credentials.json',
    redirect: 'reflex/auth/saml/login',
    profile: 'profile/card'
}